/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */

/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8.__super__.call(this);
};
/* __super__ is defined below, and used above :)
 * This is OK because below is operated at load time (as is the definition of the constructor).
 * Above is operated at construction time.
 */
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7,		// The extend defines the __super__
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8"
                 );

/**
 * onBlur - Restore the original scroll position & chat dimensions.
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * static public function onBlur(?me:MouseEvent):Bool
 * @public
 * @param {FocusEvent}  ev
 * @param {HTMLElement}  element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8.prototype.onBlurImpl = function(ev, element) {
	/** @type {com.inq.ui.Stage} */
	var stage = com.inq.ui.Stage.getInstance();
	/** @type {boolean} */
	var stageIsVisible = stage.getVisible();
	/** @type {Window} */
	var clientWin = window.parent;

	this.scrollState = com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari7.STATE_INITIAL;
	/* super.onBlurImpl */
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8.__super__.prototype.onBlurImpl.call(this, ev, element);
};


/**
 * onOrientationChange
 * Respond to orientation changes.
 *
 * static public function onOrientationChange(ev:Event):Bool
 * @public
 * @param {js.Event}  ev
 * @return {boolean}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8.prototype.onOrientationChange = function(ev) {
	this.blurFocusedElement();
	/** @type {Window} */
	var clientWin = window.parent;
	/** @type {com.inq.ui.Stage} */
	var stage = com.inq.ui.Stage.getInstance();
	/** @type {boolean} */
	var stageIsVisible = stage.getVisible();
	if (stageIsVisible)
		clientWin.scrollTo(0,0);
	return com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneSafari8.__super__.prototype.onOrientationChange.call(this, ev);
};
